import React, { useState } from 'react';
import Swal from 'sweetalert2';
import '../../../index.scss';
import { customBaseUrl, httpPost } from '../../../store/http';
import { hideLoader, showLoader } from '../../../utils/loader';
import { Modal } from 'antd';
import SearchDropdown from '../../../components/CustomDropdown/SearchDropdown';
import { searchUsers } from '../../../store/httpCalls';

const AssignCode = ({ showModal, hideModal, className }) => {
  const [options, setOptions] = useState([]);
  const [query, setQuery] = useState('');
  const [selectedUserId, setSelectedUserId] = useState('');

  const handleSelectOption = (selectedUser) => {
    setSelectedUserId(selectedUser.userId);
    setQuery(`${selectedUser.firstName} ${selectedUser.surname}`);
    setOptions([]);
  };

  const handleSearch = async (e) => {
    const val = e.target.value;
    setQuery(val);
    if (val.trim() !== '') {
      const result = await searchUsers(val);
      setOptions(result || []);
    } else {
      setOptions([]);
    }
  };

  const handleAssign = async () => {
    if (!selectedUserId) return Swal.fire('Error', 'Please select a user', 'error');

    showLoader();
    let res = await httpPost(`${customBaseUrl.referralUrl}/api/v1/admin/users/assign-or-replace-referral-code`, {
      userId: selectedUserId
    });

    hideLoader();
    if (res.status) {
      Swal.fire("Success", res.message, "success");
      hideModal(false);
    } else {
      Swal.fire('Failed', res.message, 'error');
    }
  };

  return (
    <Modal
      className={className}
      centered
      visible={showModal}
      onCancel={() => hideModal(false)}
      width={400}
      footer={null}
    >
      <div className="mb-4">
        <h5>Assign Referral Code</h5>
      </div>

      <div style={{ position: 'relative' }} className="col-md-12">
        <label className='form-label'>Search User</label>
        <input
          type='text'
          className='form-control'
          value={query}
          required
          onChange={handleSearch}
          placeholder="Type user name..."
        />
        <SearchDropdown options={options} handleClick={handleSelectOption} />
      </div>

      <div className='col-12 text-end mt-5'>
        <button className='btn btn-primary' type='button' onClick={handleAssign}>
          Save changes
        </button>
      </div>
    </Modal>
  );
};

export default AssignCode;
